module.exports = function getResource(label, vars = []) {
    let resources = {
        kilometer: 'kilometer',
        mile: 'mile',
        away: 'away',
        closed: 'Closed',
        openUntil: 'Open until ',
        getDirections: 'Get directions'
    };

    return resources[label];
};
